/**
 * Arbitrage API
 *
 * React Query wrapper for arbitrage configuration API calls.
 */

import { metricsAxios } from 'api/apiBase/axios';
import type { IBaseResponse } from 'api/apiBase/IBaseResponse';
import { mapError } from 'api/apiBase/mapError';
import { mapResponse } from 'api/apiBase/mapResponse';
import type { Response } from 'api/apiBase/Response';
import type { IArbitrageConfig } from 'types/arbitrage';

import type { GetArbitrageConfigsRequest } from './api.types';

/**
 * Fetch arbitrage configurations for a project.
 *
 * @param req - Request parameters including project id and optional abort signal.
 * @returns A promise resolving to arbitrage configurations or a mapped error response.
 * @see https://api-metrics-dev.111pg.info/swagger/index.html#/bot/get_api_v1_bot_arbitrage
 */
export async function getArbitrageConfigs(
  req: GetArbitrageConfigsRequest,
): Promise<Response<IArbitrageConfig[]>> {
  const { projectId, signal } = req;

  try {
    const response = await metricsAxios.get<IBaseResponse<IArbitrageConfig[]>>(
      '/api/v1/bot/arbitrage',
      {
        params: { project_id: projectId },
        signal,
      },
    );

    return mapResponse({ data: response.data });
  } catch (error) {
    return mapError<IArbitrageConfig[]>({ error });
  }
}
